import en from "./messages/en";
import pl from "./messages/pl";

export const SUPPORTED_LANGUAGES = ["pl", "en"];
export const DEFAULT_LANGUAGE = "pl";
export const LANGUAGE_STORAGE_KEY = "app.language";

const messages = { pl, en };

function getByPath(obj, path) {
  return String(path || "")
    .split(".")
    .filter(Boolean)
    .reduce((acc, part) => (acc && Object.prototype.hasOwnProperty.call(acc, part) ? acc[part] : undefined), obj);
}

function interpolate(template, params = {}) {
  return String(template).replace(/\{(\w+)\}/g, (_, key) => {
    if (!Object.prototype.hasOwnProperty.call(params, key)) return `{${key}}`;
    return String(params[key]);
  });
}

export function normalizeLanguage(input) {
  const next = String(input || "").trim().toLowerCase();
  return SUPPORTED_LANGUAGES.includes(next) ? next : DEFAULT_LANGUAGE;
}

export function translate(language, key, params) {
  const lang = normalizeLanguage(language);
  const primary = getByPath(messages[lang], key);
  const fallback = getByPath(messages[DEFAULT_LANGUAGE], key);
  const text = typeof primary === "string" ? primary : typeof fallback === "string" ? fallback : key;
  return interpolate(text, params);
}

